import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";

const LABEL = "text-[10px] uppercase tracking-wider text-hocp-textMuted";

/** Shared GST Tax Invoice inputs — Company Name · GSTIN · Company Address (multi-line). */
export function GSTInvoiceFields({ values, onChange, disabled = false, inputClass = "", testPrefix = "gst", labels = true, className = "" }) {
  const field = (label, node) => (labels ? <div><Label className={LABEL}>{label}</Label>{node}</div> : node);
  const mt = labels ? "mt-1" : "";
  return (
    <div className={`space-y-3 ${className}`} data-testid={`${testPrefix}-fields`}>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {field("Company name", <Input disabled={disabled} value={values.gst_company_name || ""} onChange={(e) => onChange("gst_company_name", e.target.value)}
          placeholder={labels ? "e.g. Acme Pvt Ltd" : "Company Name*"} className={`${inputClass} ${mt}`} data-testid={`${testPrefix}-company`} />)}
        {field("GSTIN", <Input disabled={disabled} value={values.gst_number || ""} onChange={(e) => onChange("gst_number", e.target.value.toUpperCase())}
          placeholder={labels ? "e.g. 27AAAAA0000A1Z5" : "GSTIN*"} className={`${inputClass} ${mt} mono uppercase`} data-testid={`${testPrefix}-number`} />)}
      </div>
      {field("Company address", <Textarea disabled={disabled} rows={2} value={values.gst_company_address || ""} onChange={(e) => onChange("gst_company_address", e.target.value)}
        placeholder={labels ? "Street, City, State — PIN" : "Company Address* (Street, City, State — PIN)"}
        className={`${inputClass} ${mt} min-h-[56px] h-auto py-2 resize-y`} data-testid={`${testPrefix}-address`} />)}
    </div>
  );
}

/** Returns an error string when GST is on and any required field is missing, else null. */
export function gstFieldsError(form) {
  if (!form.is_gst_invoice) return null;
  if (!String(form.gst_company_name || "").trim()) return "Company name is required for a GST Tax Invoice";
  if (!String(form.gst_number || "").trim()) return "GSTIN is required for a GST Tax Invoice";
  if (!String(form.gst_company_address || "").trim()) return "Company address is required for a GST Tax Invoice";
  return null;
}
